
export default {
  staticDomain: '//static.hsappstatic.net' || window.location.host,
  staticDomainPrefix: '//static.hsappstatic.net' || ('//' + window.location.host),
  currentProject: 'crm-index-ui',
  currentProjectVersion: 'static-2.45398',
  depVersions: {
  "crm-index-ui": "static-2.45398",
  "ably-hubspot-js": "static-1.435",
  "apollo-dlb": "static-3.41",
  "apollo-stack-hubspot": "static-3.43",
  "billing-management-service-client": "static-1.2248",
  "calling-orchestration-shared-library": "static-1.28753",
  "card-associated-objects-lib": "static-1.36911",
  "card-associated-objects-lib-legacy": "static-1.4375",
  "client-types": "static-1.361",
  "commerce-contract-lib": "static-1.3894",
  "commerce-products-lib": "static-1.3256",
  "commerce-shared-components-lib": "static-1.13342",
  "commerce-tools-ui-lib": "static-1.4933",
  "commerce-tours-lib": "static-1.2624",
  "contextual-settings-lib": "static-1.568",
  "credit-memos-ui-lib": "static-1.4135",
  "crm_data": "static-4.85028",
  "crm-cards-global-registry": "static-1.12907",
  "crm-common-dlb": "static-1.3583",
  "crm-component-utils": "static-1.32986",
  "crm-index-associations-lib": "static-1.4632",
  "crm-index-visualization-core": "static-1.2057",
  "crm-legacy-global-containers": "static-1.22075",
  "crm-legacy-links": "static-1.69912",
  "crm-message-bus": "static-1.34436",
  "crm-object-board-core": "static-1.10822",
  "crm-object-map": "static-1.475",
  "crm-object-search-query-utilities": "static-1.5054",
  "crm-object-search-query-utilities-test-utils": "static-1.4717",
  "crm-pipeline-board-settings-lib": "static-1.24257",
  "crm-pipelines-api-client-types": "static-1.2675",
  "customer-data-bulk-actions": "static-1.28301",
  "customer-data-objects": "static-1.5858",
  "customer-data-objects-ui-components": "static-1.11140",
  "customer-data-properties": "static-1.43656",
  "customer-data-sidebar": "static-2.38874",
  "customer-data-views-management": "static-1.20984",
  "data-fetching-client": "static-1.7772",
  "data-privacy-hub-settings-service-types": "static-1.2555",
  "demographics-client": "static-1.3671",
  "dispatcher": "static-1.108",
  "embedded-academy-lib": "static-1.9001",
  "emoji-mart": "static-3.4",
  "enviro": "static-4.284",
  "external-options-client-types": "static-1.2655",
  "feedback-loader": "static-1.25622",
  "foundations-components": "static-1.5362",
  "foundations-components-test-utils": "static-1.2848",
  "foundations-theming": "static-1.2504",
  "framework-data-schema-quick-fetch": "static-1.4936",
  "framework-data-schema-resolvers": "static-1.5031",
  "framework-data-schema-resolvers-shared-msw-handlers": "static-1.6491",
  "framework-data-table": "static-2.7307",
  "general-store": "static-6.20",
  "googlemaps-react-wrapper": "static-1.3",
  "growth-onboarding-beacon": "static-1.1676",
  "growth-payments-core": "static-1.19571",
  "head-dlb": "static-1.3234",
  "highcharts": "static-8.77",
  "history": "static-4.47",
  "hs-promise-utils": "static-1.3739",
  "hs-test-utils": "static-1.6238",
  "hub-http": "static-1.4502",
  "hubspot-apollo-client": "static-1.3091",
  "hubspot-dlb": "static-2.1055",
  "HubStyleTokens": "static-2.9765",
  "I18n": "static-7.1341",
  "immer": "static-1.33",
  "immutable": "static-2.19",
  "inbound-db-meta-service-client": "static-1.2313",
  "inbound-db-properties-service-client": "static-1.2507",
  "inbounddb-objects-service-types": "static-1.2689",
  "jasmine-immutable": "static-1.1267",
  "jasmine-runner": "static-1.4639",
  "laboratory-lib": "static-3.5524",
  "lodash": "static-1.3",
  "marketing-event-attendance-cards-ui": "static-1.3357",
  "marketplace-embed": "static-1.14105",
  "marketplace-ui-client-types": "static-1.9728",
  "object-builder-ui-client": "static-1.39489",
  "onboarding-scopes": "static-1.4822",
  "onboarding-tours": "static-1.13351",
  "payments-zero-states-lib": "static-1.12663",
  "pipeline-validation-client-types": "static-1.2448",
  "PortalIdParser": "static-2.263",
  "products-iframe-lib": "static-1.845",
  "products-ui-components": "static-1.33780",
  "property-management-iframe": "static-1.6868",
  "quartz": "static-1.4993",
  "quick-fetch": "static-1.2511",
  "raven": "static-3.3936",
  "react": "static-7.147",
  "react-dlb": "static-1.46",
  "react-dnd": "static-4.51",
  "react-dnd-html5-backend": "static-4.5",
  "react-redux": "static-7.16",
  "react-rhumb": "static-1.14856",
  "react-router-dom": "static-5.26",
  "react-utils": "static-2.3879",
  "reference-resolvers-lite": "static-1.6198",
  "reference-resolvers-lite-shared-msw-handlers": "static-1.6551",
  "reporting-data": "static-1.59732",
  "reporting-dlb": "static-1.52650",
  "reporting-testing-lib": "static-1.1667",
  "reporting-visualizations": "static-1.51812",
  "sales-views-client-types": "static-1.2667",
  "self-service-api": "static-1.8393",
  "settings-ui-lib": "static-1.10804",
  "signup-constants": "static-1.15155",
  "styled-components": "static-2.40",
  "superstore": "static-1.3036",
  "svh-onboarding-config-shared-lib": "static-1.1288",
  "tinymce": "static-6.5",
  "transmute": "static-2.29",
  "trial-components-library": "static-1.9961",
  "ui-addon-draggable": "static-2.1191",
  "ui-addon-integrations-directory-panel": "static-2.6227",
  "ui-addon-upgrades": "static-9.15246",
  "ui-components-test-utils": "static-1.3905",
  "UIComponents": "static-3.6714",
  "usage-tracker-core": "static-1.5588",
  "user-context": "static-1.3408",
  "webpack-env": "static-1.54",
  "wootric-nps": "static-1.5256",
  "account-and-billing-components": "static-1.15202",
  "account-and-billing-fintech-outages": "static-3.13951",
  "accounting-extension-card-ui": "static-1.29509",
  "accounting-integrations-ui-components": "static-1.4027",
  "ai-components-ui-library": "static-1.4498",
  "apollo-link-hub-http": "static-2.3067",
  "attribution-sidebar-cards": "static-1.37643",
  "BizOpsCrmUIComponents": "static-1.38689",
  "call-widget-addon": "static-2.25119",
  "calling-integration-sdk-support": "static-1.23313",
  "calling-integration-timeline-event": "static-1.11009",
  "calling-internal-common": "static-1.29374",
  "calling-lifecycle-internal": "static-1.56390",
  "calling-ui-library": "static-1.62310",
  "card-biz-ops-customer-success-lib": "static-1.69717",
  "card-biz-ops-domain-controls-lib": "static-1.69718",
  "card-biz-ops-related-contacts-lib": "static-1.69717",
  "card-crm-attribution-lib": "static-1.47965",
  "card-deal-collaborators-lib": "static-1.30910",
  "card-deal-shared-view-lib": "static-1.61261",
  "card-engagement-attachments-lib": "static-1.66078",
  "card-gdpr-subscriptions-card-lib": "static-1.40379",
  "card-integration-card-lib": "static-1.66302",
  "card-linked-in-sales-navigator-lib": "static-1.33433",
  "card-lists-lib": "static-1.64117",
  "card-past-conversations-lib": "static-1.31654",
  "card-payment-history-lib": "static-1.29403",
  "card-playbooks-lib": "static-1.56200",
  "card-preview-highlight-lib": "static-1.68600",
  "card-profile-products-lib": "static-1.49605",
  "card-profile-quotes-lib": "static-1.76911",
  "card-properties-lib": "static-1.36867",
  "card-sales-activities-timeline": "static-1.30253",
  "card-target-account-lib": "static-1.65693",
  "card-website-activity-lib": "static-1.66522",
  "chatspot-widget-iframe": "static-1.13585",
  "collaboration-sidebar": "static-1.50175",
  "commerce-billing-lib": "static-1.13136",
  "commerce-subscription-cards-lib": "static-1.24163",
  "commerce-subscription-lib": "static-1.29337",
  "composer-plugins": "static-1.64706",
  "conversations-thread-view-crm-events": "static-1.27873",
  "copilot-toolkit": "static-1.4361",
  "credit-memos-iframe-lib": "static-1.4139",
  "crm_components": "static-3.85028",
  "crm_schema": "static-3.85063",
  "crm_ui": "static-5.84986",
  "crm_universal": "static-1.19967",
  "crm-activity-creator-interaction-window": "static-1.38984",
  "crm-activity-creator-interactions-legacy": "static-1.29453",
  "crm-activity-creator-widgets": "static-1.45035",
  "crm-associations-table": "static-1.34836",
  "crm-cards": "static-1.37554",
  "crm-cards-sdk": "static-1.36255",
  "crm-command-handler": "static-1.28505",
  "crm-display-components": "static-1.18737",
  "crm-events-components": "static-1.53494",
  "crm-events-data": "static-1.53506",
  "crm-fe-perf": "static-1.21248",
  "crm-index-ui-toolbar": "static-1.1302",
  "crm-index-view-table-edit-columns-modal": "static-1.15030",
  "crm-index-visualization-toolbar": "static-1.1724",
  "crm-index-visualization-toolbar-test-utils": "static-1.1097",
  "crm-links": "static-1.4342",
  "crm-object-board": "static-1.20745",
  "crm-object-board-card": "static-1.10820",
  "crm-object-preview": "static-1.19692",
  "crm-object-table": "static-1.15954",
  "crm-timeline": "static-1.81834",
  "crm-timeline-tasks": "static-1.30790",
  "cropperjs": "static-1.10",
  "cssUtils": "static-1.372",
  "customer-data-board": "static-1.18224",
  "customer-data-board-card": "static-1.18185",
  "customer-data-bulk-actions-container": "static-1.14013",
  "customer-data-communicator": "static-1.38355",
  "customer-data-email": "static-1.14953",
  "customer-data-filters-ui": "static-1.31931",
  "customer-data-property-utils": "static-1.6173",
  "customer-data-reference-ui-components": "static-1.11183",
  "customer-data-rte": "static-1.27449",
  "customer-data-ui-utilities": "static-1.7989",
  "deal-registration-ui": "static-1.28608",
  "deal-splits-cards-ui": "static-1.37704",
  "deal-splits-sidebar": "static-1.37609",
  "draft-email-branding-plugin": "static-2.18644",
  "draft-js": "static-5.37",
  "draft-plugins": "static-2.18409",
  "draft-signature-plugin": "static-1.18425",
  "draft-smart-detections": "static-1.8443",
  "email-confirm-ui": "static-2.3861",
  "EmailSignatureEditor": "static-1.19029",
  "ExportDialog": "static-6.8641",
  "ExtensionInstallHelpers": "static-1.520",
  "file-manager-components": "static-1.16545",
  "FileManagerLib": "static-1.32187",
  "flywheel-feedback-panel-components": "static-1.5517",
  "foundations-assets": "static-1.3146",
  "framework-app-settings-features-lib": "static-1.3290",
  "frontend-preferences-client": "static-1.6146",
  "getting-started-shared-tasks": "static-1.9827",
  "graphql": "static-1.56",
  "growth-data-modal": "static-1.3424",
  "growth-feature-usage-components": "static-1.3177",
  "growth-feature-usage-data": "static-1.3395",
  "growth-onboarding-empty-states": "static-1.3331",
  "HeadJS": "static-2.541",
  "hubspot-prosemirror": "static-1.12093",
  "hubspot-url-utils": "static-1.2706",
  "HubStyle": "static-2.10074",
  "icons": "static-2.589",
  "in-meeting-experience-ui-components": "static-1.15283",
  "InboxConnectUtils": "static-4.8916",
  "integration-settings-components": "static-1.9289",
  "integrations-directory-panel-lib": "static-1.6797",
  "invoices-card-lib": "static-1.50053",
  "invoices-iframe-lib": "static-1.49980",
  "invoices-ui-lib": "static-1.47922",
  "lead-tracking-lib": "static-1.31681",
  "marketing-contacts-lib": "static-1.7389",
  "marketing-contacts-ui": "static-1.5820",
  "marketing-event-cards-ui": "static-1.29754",
  "marketplace-ui-apps-core": "static-1.10860",
  "marketplace-ui-common": "static-1.12324",
  "metrics-js": "static-1.8013",
  "mobile-manifest-mixins": "static-1.312",
  "native-integrations-shared-strings": "static-1.6060",
  "nav-meta": "static-1.24580",
  "object-comments-thread-lib": "static-1.4592",
  "onboarding-tours-client": "static-1.2786",
  "orders-card-lib": "static-1.15199",
  "panel-deal-registration-ai-summary-lib": "static-1.20197",
  "partner-shared-view-ui": "static-1.40537",
  "playbooks-modal": "static-1.73374",
  "playlists-lib": "static-1.5763",
  "products-highlight-card-lib": "static-1.11545",
  "property-translator": "static-1.3668",
  "quartz-core": "static-1.4212",
  "quotes-ui-components": "static-1.43029",
  "quotes-ui-lib": "static-1.72103",
  "react-beautiful-dnd": "static-1.13",
  "react-colorpicker": "static-2.8489",
  "react-immutable-render-mixin": "static-1.9",
  "react-select-plus": "static-1.65",
  "recent-activities-card": "static-1.51358",
  "redux": "static-4.16",
  "redux-thunk": "static-2.43",
  "redux-toolkit": "static-1.7",
  "reference-resolvers": "static-1.6398",
  "reporting-action-components": "static-1.34230",
  "reporting-crm-object-table": "static-1.906",
  "reporting-enablement": "static-1.15017",
  "reporting-ui-components": "static-2.57015",
  "reselect": "static-2.16",
  "rich-text-lib": "static-1.16590",
  "rpc-client-utils": "static-1.3001",
  "SalesContentIndexUI": "static-3.6193",
  "salesforce-sync-card-ui": "static-1.7150",
  "SalesTemplateEditor": "static-3.25249",
  "sanitize-text": "static-1.6454",
  "sequences-lib": "static-1.5033",
  "SharedI18nStrings": "static-1.160",
  "subscriptions-components": "static-1.39677",
  "svh-conversations-settings-lib": "static-1.1290",
  "tasks-lib": "static-1.30864",
  "timezone-utils": "static-2.3543",
  "transcript-sidebar": "static-1.60110",
  "trellis-ecosystem": "static-1.3762",
  "ui-addon-avatars": "static-2.7692",
  "ui-addon-form-validation": "static-1.9291",
  "ui-addon-i18n": "static-1.9161",
  "ui-addon-iframeable": "static-1.7163",
  "ui-addon-opt": "static-4.6970",
  "ui-addon-react-router-dom": "static-1.7866",
  "ui-addon-scriptloader": "static-1.10613",
  "ui-addon-teams": "static-1.18960",
  "ui-asset-management-lib": "static-1.8306",
  "ui-business-units-lib": "static-1.7114",
  "ui-gdpr-components": "static-1.8511",
  "ui-shepherd-react": "static-3.8227",
  "ui-universal-auth": "static-1.6976",
  "usage-tracker": "static-1.5738",
  "usage-tracker-container": "static-1.5728",
  "atom": "static-1.3574",
  "hs-lodash": "static-4.40",
  "planout": "static-5.12",
  "react-immutable-proptypes": "static-2.8",
  "react-input-autosize": "static-2.17",
  "sanitize": "static-1.2629",
  "hs-promise-rejection-tracking": "static-1.3563",
  "raven-hubspot": "static-1.4243",
  "classnames": "static-2.10",
  "hoist-non-react-statics": "static-3.9",
  "bend-plugin-trellis-migration": "static-1.1987",
  "moment": "static-3.26",
  "react-dom": "static-7.85",
  "bend-plugin-quartz": "static-1.1270",
  "quartz-webpack": "static-1.1217",
  "ably": "static-1.18",
  "calling-orchestration-schema": "static-1.28978",
  "calling-global-api": "static-1.55008",
  "campaigns-lib": "static-1.20339",
  "card-payment-highlight-lib": "static-1.29537",
  "customer-data-tracking": "static-1.5084",
  "payment-link-components": "static-1.16569",
  "payments-embed-points-lib": "static-1.8108",
  "persist-promise": "static-1.2014",
  "PatternValidationJS": "static-1.437",
  "usage-tracker-session-replay": "static-1.2954",
  "utility-belt": "static-1.847",
  "products-ui-components-shared-msw-handlers": "static-1.6790",
  "hs-story-utils": "static-1.7575",
  "msw": "static-1.39",
  "payments-enrollment-embed-lib": "static-1.15990",
  "StyleGuideUI": "static-3.444",
  "ui-images": "static-2.784",
  "cv-backend-services": "static-1.1007",
  "growth-onboarding-confetti": "static-1.1376",
  "payments-post-enroll-local-storage-lib": "static-1.3338",
  "prosemirror": "static-1.13",
  "qrcode-generator": "static-1.41",
  "react-dnd-compat": "static-1.2842",
  "adobe-sign-cards-lib": "static-1.10930",
  "ai-addon-copilot-preview": "static-1.3710",
  "automation-ui-crm-card-workflows-invoker": "static-1.3379",
  "buyer-intent-card": "static-1.14317",
  "card-call-summaries-lib": "static-1.28297",
  "card-company-summary-lib": "static-1.11835",
  "card-customer-spend-trends-lib": "static-1.19120",
  "card-flywheel-activity-history-lib": "static-1.396",
  "card-flywheel-company-overview-lib": "static-1.9425",
  "card-flywheel-high-intent-associated-contacts-lib": "static-1.9425",
  "card-guest-access-management-lib": "static-1.1279",
  "flywheel-growth-plans-crm-card": "static-1.417",
  "card-guided-execution-activities": "static-1.2346",
  "card-knowledge-base-lib": "static-1.6385",
  "card-lead-insights": "static-1.6941",
  "card-lead-qualification-lib": "static-1.23181",
  "card-object-highlight-lib": "static-1.62",
  "card-object-summary-lib": "static-1.2225",
  "card-other-tickets-lib": "static-1.14660",
  "card-partner-client-portal-usage-outcomes-lib": "static-1.23264",
  "card-partner-client-unified-usage-score-lib": "static-1.17629",
  "card-tasks-timeline-lib": "static-1.9250",
  "card-ticket-summary-lib": "static-1.11097",
  "crm-actions": "static-1.4249",
  "crm-associations-pivot": "static-1.32966",
  "crm-clv-report": "static-1.1624",
  "crm-data-highlights": "static-1.35374",
  "crm-events-viz-cards": "static-1.34661",
  "crm-events-viz-totals": "static-1.26214",
  "crm-extension": "static-1.34695",
  "crm-pipeline-approvals-lib": "static-1.17460",
  "crm-properties-list": "static-1.32012",
  "crm-property-history": "static-1.10072",
  "crm-quick-actions": "static-1.11522",
  "crm-relative-timeline": "static-1.11950",
  "crm-report": "static-1.35581",
  "crm-simple-deadline": "static-1.12169",
  "crm-stage-tracker": "static-1.30546",
  "crm-statistics": "static-1.24590",
  "customer-overview-card-lib": "static-1.2858",
  "customer-success-contacts-card-lib": "static-1.11188",
  "datawell-report-crm-card": "static-1.12673",
  "deal-summary-components": "static-1.13744",
  "docusign-cards-lib": "static-1.20519",
  "guided-actions-card": "static-1.7625",
  "guided-selling-stage-tracker-card": "static-1.4083",
  "health-score-card-lib": "static-1.14471",
  "help-desk-insights-lib-crm-cards": "static-1.16340",
  "intelligence-overview-card": "static-1.8149",
  "intelligence-overview-lib": "static-1.7040",
  "invoices-history-card-lib": "static-1.24337",
  "lead-scores-card": "static-1.10635",
  "legacy-sidebar-card-lib": "static-1.27463",
  "payment-schedule-card-lib": "static-1.21525",
  "playbooks-card": "static-1.36085",
  "predictive-scores-card": "static-1.23652",
  "process-guide-cards": "static-1.2985",
  "products-cards-lib": "static-1.2854",
  "purchase-history-lib": "static-1.13885",
  "customer-data-properties-shared-msw-handlers": "static-1.5735",
  "ts-schema": "static-1.2701",
  "framework-builder-read-service-client": "static-1.2627",
  "hub-http-shared-msw-handlers": "static-1.6405",
  "multi-currency-client-types": "static-1.2424",
  "fast-json-stable-stringify": "static-1.4",
  "csstype": "static-1.38",
  "jasmine": "static-4.2622",
  "usage-tracker-public": "static-1.5549",
  "content-assistance-lib": "static-1.5664",
  "crm-record-access-management-lib": "static-1.18916",
  "customer-data-content": "static-1.23449",
  "draft-content-plugins": "static-1.22762",
  "draft-convert": "static-2.31",
  "draft-extend": "static-2.46",
  "enrichment-properties-lib": "static-1.7866",
  "FireAlarmUi": "static-1.3207",
  "flux-actions": "static-1.260",
  "marketing-contacts-client": "static-1.5821",
  "pipeline-governance-client-types": "static-1.2714",
  "prospecting-agent-lib": "static-1.4726",
  "react-virtualized": "static-2.71",
  "subscriptions-client": "static-1.39917",
  "surveymonkey-crm-card": "static-1.33753",
  "task-forms-lib": "static-1.33679",
  "ui-coaching-tips": "static-1.20308",
  "avatar-components": "static-1.667",
  "autolinker": "static-3.11",
  "conditional-properties-service-client": "static-1.2508",
  "google-libphonenumber": "static-1.9",
  "calling-error-reporting": "static-1.29380",
  "card-subscription-highlight-lib": "static-1.31761",
  "invoices-highlight-card-lib": "static-1.47909",
  "orders-highlight-card-lib": "static-1.15482",
  "project-storage": "static-1.2981",
  "quotes-highlight-card-lib": "static-1.63392",
  "crm-export-dialog": "static-1.4546",
  "customer-data-filters": "static-1.45745",
  "FormUrlGenerator": "static-2.2994",
  "testing-library": "static-1.118",
  "academy-common-lib": "static-1.8459",
  "bend-plugin-foundations-components": "static-1.1630",
  "floating-ui": "static-1.26",
  "foundations-theming-specialty": "static-1.221",
  "framer-motion": "static-1.38",
  "react-aria": "static-1.36",
  "tanstack-table": "static-1.23",
  "ui-fonts": "static-1.329",
  "bend-plugin-foundations-theming": "static-1.987",
  "foundations-theming-base": "static-1.1489",
  "customer-data-associations": "static-1.5452",
  "growth-onboarding-feedback-components": "static-1.4717",
  "commerce-analytics-service-client": "static-1.2059",
  "hs-test-utils-bend-plugin": "static-1.1349",
  "i18n-data": "static-1.193",
  "moment-timezone": "static-5.51",
  "magpie-lib": "static-1.3893",
  "marketplace-ui-details": "static-1.2225",
  "navigation-components": "static-1.12943",
  "ui-shepherd-tracker": "static-1.5608",
  "property-description-translator": "static-1.2130",
  "quartz-core-utils": "static-1.1860",
  "reporting-client-types": "static-1.1609",
  "redux-observable": "static-1.11",
  "ReduxMessenger": "static-2.8723",
  "rxjs": "static-5.10",
  "underscore": "static-1.8",
  "conversations-async-data": "static-2.5930",
  "conversations-error-reporting": "static-1.7120",
  "conversations-http": "static-1.3038",
  "conversations-internal-schema": "static-1.10873",
  "conversations-message-history": "static-1.9301",
  "routing-ui": "static-1.14164",
  "salesImages": "static-1.495",
  "trials-service-types": "static-1.2370",
  "react-flip-move": "static-1.44",
  "feature-store-service-types": "static-1.2962",
  "growth-monetization-service-types": "static-1.2969",
  "upgrade-management-service-types": "static-1.2953",
  "getting-started-shared-tasks-store": "static-1.8945",
  "final-form": "static-1.37",
  "fintech-outages-service-client-types": "static-1.10906",
  "subscription-experience-data-types": "static-1.9071",
  "transactions-exp-service-client-types": "static-1.10902",
  "conversations-skeleton-state": "static-1.5660",
  "integrations-lib": "static-1.9190",
  "chatspot-client-types": "static-1.7775",
  "chatspot-core": "static-1.13589",
  "ContentUtils": "static-1.61379",
  "sassPrefix": "static-1.127",
  "report-customization-components": "static-1.7122",
  "reporting-snowflake": "static-1.48358",
  "activity-history-lib": "static-1.217",
  "assisted-buying-components": "static-1.5233",
  "bet-customer-success-shared-ui": "static-1.10818",
  "domain-review-history-lib": "static-1.296",
  "industries-core": "static-1.5008",
  "calling-client-interface": "static-1.67549",
  "calling-cross-tab-library": "static-1.17313",
  "calling-integration-cross-tab": "static-1.15083",
  "calling-lifecycle-messages": "static-1.48687",
  "calling-lifecycle-usage-tracker": "static-1.4164",
  "calling-usage-tracker": "static-1.4751",
  "conversations-prop-types": "static-1.5694",
  "shared-worker-versioning": "static-1.9301",
  "universal-associations-select": "static-1.8998",
  "hubspot-prosemirror-plugins": "static-1.12086",
  "redux-actions": "static-3.7",
  "share-transcript-modal": "static-1.49753",
  "twilio-voice-sdk": "static-1.48",
  "worker-connection-library": "static-1.9611",
  "SafeStorage": "static-1.2674",
  "ui-partner-confirmation-links-components": "static-1.19962",
  "FileManagerCore": "static-1.32045",
  "ui-extensions-canvas-renderer": "static-1.13152",
  "crm-activity-creator-data": "static-1.39529",
  "multi-account-crm-panel-lib": "static-1.10163",
  "sequences-crm-lib": "static-1.20862",
  "quotes-modal-lib": "static-1.94057",
  "call-timeline-event": "static-1.48316",
  "crm-events": "static-1.53501",
  "crm-meetings-components-lib": "static-1.19623",
  "svh-tickets-lib": "static-1.11791",
  "recording-review-components-lib": "static-1.24174",
  "composer-data": "static-1.24096",
  "conversations-inbox-message-history": "static-1.27756",
  "conversations-infrastructure": "static-1.7168",
  "conversations-internal-pub-sub": "static-1.14233",
  "conversations-platform": "static-1.2757",
  "conversations-thread-data": "static-1.61208",
  "crm-events-viz-core": "static-1.27005",
  "hubspotter-http": "static-1.3088",
  "react-transition-group": "static-1.7",
  "ui-addon-conversations-settings": "static-2.25981",
  "ui-suspension-banners-lib": "static-1.4673",
  "zorse-crm-components-lib": "static-1.5260",
  "crm-activity-creator-interactions": "static-1.38256",
  "framework-scoring-history-panel-lib": "static-1.8937",
  "MeetingsLib": "static-2.51862",
  "hub-http-contrib": "static-1.1459",
  "task-queues": "static-1.26551",
  "ui-addon-video-player": "static-1.7038",
  "card-past-feedback-lib": "static-1.34615",
  "location-customization-utils-lib": "static-1.2382",
  "all-properties-panel-lib": "static-1.735",
  "crm-events-viz-timeline": "static-1.34669",
  "customer-data-modals": "static-1.2966",
  "merge-modal-lib": "static-1.4778",
  "predictive-scores-panel": "static-1.22654",
  "property-history-panel": "static-1.17985",
  "crm-source-interpretation-lib": "static-1.3525",
  "partner-shared-messages-lib": "static-1.11333",
  "ql-visibility-lib": "static-1.2364",
  "redux-mock-store": "static-1.8",
  "automation-platform-service-types": "static-1.1785",
  "sales-execution-components": "static-1.6278",
  "credit-memos-highlight-card-lib": "static-1.3492",
  "breeze-intelligence-kit": "static-1.3422",
  "policy-lib": "static-1.5065",
  "analytics_js": "static-1.2871",
  "blueimp-md5": "static-1.8",
  "calling-cross-tab-messaging": "static-1.17311",
  "feedback-schema": "static-1.46292",
  "forms-utils-lib": "static-1.9267",
  "FormsCommonComponents": "static-1.79122",
  "integrations-tracking-lib": "static-1.3660",
  "MeetingsBase": "static-1.53452",
  "outpost": "static-1.2517",
  "partner-poi-timeline-event": "static-1.32138",
  "qualified-leads-embedded-lib": "static-1.40176",
  "quotes-crm-events-lib": "static-1.35480",
  "react-table": "static-1.15",
  "sales-clients-common": "static-1.43664",
  "sequences-client-types-lib": "static-1.4889",
  "sequences-crm-events-lib": "static-1.20668",
  "settings-ui-nav": "static-2.8286",
  "social-components-lib": "static-1.27246",
  "ui-addon-sales-email": "static-1.3478",
  "ui-tour-react": "static-1.10177",
  "urlinator": "static-1.2830",
  "outreach-assistant-email-generation": "static-1.1376",
  "quotes-client-types": "static-1.29468",
  "sales-email-signature-service-client": "static-1.2280",
  "customer-data-filters-ui-msw-helpers": "static-1.14363",
  "signup-ui-lego-core": "static-1.17166",
  "viral-links-lib": "static-1.5063",
  "media-bridge-lib": "static-1.15827",
  "video-data-lib": "static-1.27557",
  "FileManagerImages": "static-1.29696",
  "hub-http-janus": "static-1.611",
  "trellis-story-utils": "static-1.2803",
  "knowledge-content-types": "static-1.7343",
  "ui-addon-emoji-picker": "static-1.8176",
  "in-meeting-experience-client-types": "static-1.11982",
  "content-embed-lib": "static-1.5446",
  "crm-record-cards-service-types": "static-1.2387",
  "remote-ui": "static-1.37",
  "ui-extensions": "static-1.13244",
  "ui-extensions-remote-renderer": "static-1.10837",
  "universal-page-editor-lib": "static-1.1211",
  "developer-experience-shared-components": "static-1.8264",
  "immutable-less": "static-1.2838",
  "ui-extensibility-client-types": "static-1.2558",
  "react-window": "static-1.13",
  "call-summary": "static-1.29702",
  "markdown-it": "static-1.6",
  "hubspotter-http-shared-msw-handlers": "static-1.6403",
  "platform-navigation-bootstrap": "static-1.10478",
  "dashboard-lib": "static-1.73669",
  "share-with-third-party-component-lib": "static-1.6885",
  "data-quality-ui-library": "static-1.6022",
  "html-to-image": "static-1.27",
  "reporting-plugins": "static-1.5494",
  "reporting-reports": "static-1.59421",
  "data-token-picker": "static-1.13179",
  "content-permissions-service-types-lib": "static-1.2720",
  "sales-templates-service-types-lib": "static-1.2720",
  "sequences-personalization-token-plugin": "static-1.6243",
  "sequences-smart-detections-plugin": "static-1.5956",
  "permission-components": "static-1.3625",
  "campaigns-build-lib": "static-1.5250",
  "marketing-platform-lib": "static-1.4911",
  "growth-onboarding-reliability": "static-1.3412",
  "sales-checkout-service-client": "static-1.2071",
  "amplitude-session-replay-browser": "static-1.6",
  "stripe-embedded-components": "static-1.4362",
  "integrations-error-boundary-lib": "static-1.6604",
  "ai-settings-ui-library": "static-1.5121",
  "automation-enrollment-service-types": "static-1.2230",
  "crm-cards-test-utils": "static-1.36104",
  "renewal-center-service-types": "static-1.2464",
  "submissions-lib": "static-1.39271",
  "ui-forms-components": "static-1.7262",
  "portal-details-components": "static-1.11972",
  "ui-extensions-plugin-flywheel": "static-1.7779",
  "ui-product-approvals": "static-1.22699",
  "customer-success-client-types": "static-1.12801",
  "sales-enablement-lib": "static-1.9811",
  "sales-leader-insights-components-lib": "static-1.11789",
  "guided-actions-lib": "static-1.12495",
  "framework-scoring-client-types": "static-1.9989",
  "fsm": "static-1.1971",
  "card-bet-associated-companies-lib": "static-1.69696",
  "card-bet-deal-support-requests-lib": "static-1.60438",
  "card-bet-quotes-lib": "static-1.69703",
  "card-deal-splits-lib": "static-1.37090",
  "card-flywheel-ql-summary-lib": "static-1.38584",
  "card-flywheel-recent-conversions-lib": "static-1.38585",
  "card-invoices-lib": "static-1.48887",
  "card-marketing-event-about-lib": "static-1.48669",
  "card-marketing-event-activity-lib": "static-1.48668",
  "card-prospecting-notes": "static-1.30253",
  "card-qualified-leads-lib": "static-1.69859",
  "card-sfdcsync-lib": "static-1.48739",
  "card-workflows-lib": "static-1.65864",
  "integrations-sync-card-ui": "static-1.19844",
  "partner-poi-crm-card": "static-1.12109",
  "recording-preview-card": "static-1.9525",
  "ui-sales-order-wizard-card": "static-1.24809",
  "predictive-scores-lib-components": "static-1.21048",
  "process-guide-chirp": "static-1.2816",
  "prospecting-agent-client-types": "static-1.21849",
  "deep-diff": "static-1.5",
  "academy-service-client": "static-1.2542",
  "idb-keyval": "static-1.18",
  "magpie-types": "static-1.3353",
  "simple-logging-lib": "static-1.1326",
  "marketplace-ui-reviews": "static-1.12284",
  "marketplace-ui-tracking": "static-1.6498",
  "cms-field-types": "static-1.3058",
  "content-icons-ui": "static-1.1841",
  "reporting-datasets-permissions-lib": "static-1.5214",
  "fintech-buying-service-clients": "static-1.2162",
  "account-and-billing-contacts-usage": "static-2.16659",
  "signup-ui-full-screen-search": "static-1.9635",
  "crm-pipeline-events-ui": "static-1.20434",
  "conversations-calling-message": "static-1.52090",
  "conversations-routing-lib": "static-1.4468",
  "conversations-visibility-tools": "static-1.4037",
  "data-ops-fullstory": "static-1.3581",
  "re-reselect": "static-1.4",
  "signup-ui-url-generator": "static-2.6289",
  "usage-tracker-anonymous": "static-1.4155",
  "usage-tracker-multi": "static-1.4152",
  "automation-ui-core": "static-2.14699",
  "automation-ui-permissions": "static-1.13061",
  "forms-ai-lib": "static-1.1584",
  "react-tinymce": "static-1.48872",
  "SharedLegalStrings": "static-1.1264",
  "tinymce-config": "static-2.47998",
  "meetings-client-types": "static-1.2412",
  "messaging-types-lib": "static-1.38117",
  "emoji-regex": "static-1.7",
  "apps-service-types": "static-1.2639",
  "oauth-service-types": "static-1.2570",
  "platform-infra-nav-components": "static-1.6219",
  "campaign-roi-lib": "static-1.755",
  "stripe-connect-js": "static-1.34",
  "customer-data-sidebar-test-utils": "static-1.33553",
  "form-builder-ui": "static-1.7275",
  "user-configuration-lib": "static-1.22334",
  "ui-deal-management-components-lib": "static-1.14317",
  "automation-ui-routing": "static-1.14123",
  "automation-ui-source-apps": "static-1.11845",
  "tinymce-themes": "static-1.49966",
  "interframe": "static-3.3053",
  "tinymce-data": "static-1.34081",
  "tinymce-plugins": "static-1.51112",
  "ContentData": "static-1.61456",
  "marketing-email-service-types": "static-1.1198",
  "layout-dnd-components": "static-1.10114",
  "layout-dnd-utils": "static-1.9089",
  "app-users-service-client": "static-1.3132",
  "framework-listing-lib": "static-2.20183",
  "mini-checkout-client": "static-1.22941",
  "onboarding-utils": "static-1.3559",
  "ui-coaching-tips-shared-config": "static-1.20294",
  "NamespacedHubStyle": "static-2.7787",
  "codemirror": "static-5.67",
  "react-codemirror": "static-1.8849",
  "layout-data-lib": "static-1.7414",
  "app-users-service-types": "static-1.2538",
  "framework-listing-lib-shared-msw-handlers": "static-1.6296",
  "touchless-buying-components": "static-1.2658",
  "merchandise-lib": "static-1.219",
  "settings-content-modals": "static-1.37602",
  "diff-match-patch": "static-1.7",
  "browser-eslint": "static-2.57",
  "checkout-service-types": "static-1.2482",
  "company-details-components": "static-1.4107",
  "payment-method-components": "static-1.4788",
  "upgrade-catalog-service-types": "static-1.2366",
  "access-control-lib": "static-1.8642",
  "EmailComponents": "static-1.46740",
  "EmailData": "static-1.45414",
  "redux-less": "static-2.7687",
  "company-details-service-types": "static-1.2063",
  "billing-payments-client-types": "static-1.2401",
  "ContentComponents": "static-2.64337",
  "messaging-editing-lib": "static-1.38382",
  "ui-tool-access": "static-1.8290",
  "automation-ui-types": "static-1.12763",
  "data-token-views": "static-1.13163",
  "simple-menus-core": "static-1.12891",
  "simple-menus-lib": "static-1.14409",
  "ui-memberships-settings-lib": "static-1.26127",
  "videoconference-integration-components": "static-1.4260",
  "automation-applications-service-types": "static-1.2141",
  "ContentEditorUI": "static-2.69629",
  "short-messages-app-service-client": "static-1.2439",
  "web-interactives-components": "static-1.10632",
  "web-interactives-data": "static-1.10633",
  "seamless-immutable": "static-7.6",
  "backbone": "static-1.6",
  "content-management-data-lib": "static-1.3336",
  "copilot-plugins": "static-1.4335",
  "cta-picker": "static-1.29408",
  "editor-components": "static-1.11212",
  "editor-iframe-lib": "static-1.6535",
  "error-messaging-js": "static-1.3556",
  "pictos": "static-7.156",
  "redux-request-state": "static-1.8845",
  "smart-content-core": "static-1.35344",
  "smart-content-lib": "static-1.35999",
  "social-composer-lib": "static-1.51772",
  "structured-content-lib": "static-1.18292",
  "theme-previewer-lib": "static-1.45657",
  "tinymce-copilot": "static-1.10066",
  "ui-active-theme-content-creator-lib": "static-1.29456",
  "xray-recommendation-lib": "static-1.5118",
  "jquery": "static-3.6",
  "ai-rendering-library": "static-1.3385",
  "ui-brand-identity-lib": "static-1.6359",
  "fuzzy": "static-1.8",
  "codemirror-dlb": "static-1.51181",
  "redux-undo": "static-1.10",
  "highlight.js": "static-1.45"
},
  depPathPrefixes: {
  "crm-index-ui": "/crm-index-ui/static-2.45398",
  "ably-hubspot-js": "/ably-hubspot-js/static-1.435",
  "apollo-dlb": "/apollo-dlb/static-3.41",
  "apollo-stack-hubspot": "/apollo-stack-hubspot/static-3.43",
  "billing-management-service-client": "/billing-management-service-client/static-1.2248",
  "calling-orchestration-shared-library": "/calling-orchestration-shared-library/static-1.28753",
  "card-associated-objects-lib": "/card-associated-objects-lib/static-1.36911",
  "card-associated-objects-lib-legacy": "/card-associated-objects-lib-legacy/static-1.4375",
  "client-types": "/client-types/static-1.361",
  "commerce-contract-lib": "/commerce-contract-lib/static-1.3894",
  "commerce-products-lib": "/commerce-products-lib/static-1.3256",
  "commerce-shared-components-lib": "/commerce-shared-components-lib/static-1.13342",
  "commerce-tools-ui-lib": "/commerce-tools-ui-lib/static-1.4933",
  "commerce-tours-lib": "/commerce-tours-lib/static-1.2624",
  "contextual-settings-lib": "/contextual-settings-lib/static-1.568",
  "credit-memos-ui-lib": "/credit-memos-ui-lib/static-1.4135",
  "crm_data": "/crm_data/static-4.85028",
  "crm-cards-global-registry": "/crm-cards-global-registry/static-1.12907",
  "crm-common-dlb": "/crm-common-dlb/static-1.3583",
  "crm-component-utils": "/crm-component-utils/static-1.32986",
  "crm-index-associations-lib": "/crm-index-associations-lib/static-1.4632",
  "crm-index-visualization-core": "/crm-index-visualization-core/static-1.2057",
  "crm-legacy-global-containers": "/crm-legacy-global-containers/static-1.22075",
  "crm-legacy-links": "/crm-legacy-links/static-1.69912",
  "crm-message-bus": "/crm-message-bus/static-1.34436",
  "crm-object-board-core": "/crm-object-board-core/static-1.10822",
  "crm-object-map": "/crm-object-map/static-1.475",
  "crm-object-search-query-utilities": "/crm-object-search-query-utilities/static-1.5054",
  "crm-object-search-query-utilities-test-utils": "/crm-object-search-query-utilities-test-utils/static-1.4717",
  "crm-pipeline-board-settings-lib": "/crm-pipeline-board-settings-lib/static-1.24257",
  "crm-pipelines-api-client-types": "/crm-pipelines-api-client-types/static-1.2675",
  "customer-data-bulk-actions": "/customer-data-bulk-actions/static-1.28301",
  "customer-data-objects": "/customer-data-objects/static-1.5858",
  "customer-data-objects-ui-components": "/customer-data-objects-ui-components/static-1.11140",
  "customer-data-properties": "/customer-data-properties/static-1.43656",
  "customer-data-sidebar": "/customer-data-sidebar/static-2.38874",
  "customer-data-views-management": "/customer-data-views-management/static-1.20984",
  "data-fetching-client": "/data-fetching-client/static-1.7772",
  "data-privacy-hub-settings-service-types": "/data-privacy-hub-settings-service-types/static-1.2555",
  "demographics-client": "/demographics-client/static-1.3671",
  "dispatcher": "/dispatcher/static-1.108",
  "embedded-academy-lib": "/embedded-academy-lib/static-1.9001",
  "emoji-mart": "/emoji-mart/static-3.4",
  "enviro": "/enviro/static-4.284",
  "external-options-client-types": "/external-options-client-types/static-1.2655",
  "feedback-loader": "/feedback-loader/static-1.25622",
  "foundations-components": "/foundations-components/static-1.5362",
  "foundations-components-test-utils": "/foundations-components-test-utils/static-1.2848",
  "foundations-theming": "/foundations-theming/static-1.2504",
  "framework-data-schema-quick-fetch": "/framework-data-schema-quick-fetch/static-1.4936",
  "framework-data-schema-resolvers": "/framework-data-schema-resolvers/static-1.5031",
  "framework-data-schema-resolvers-shared-msw-handlers": "/framework-data-schema-resolvers-shared-msw-handlers/static-1.6491",
  "framework-data-table": "/framework-data-table/static-2.7307",
  "general-store": "/general-store/static-6.20",
  "googlemaps-react-wrapper": "/googlemaps-react-wrapper/static-1.3",
  "growth-onboarding-beacon": "/growth-onboarding-beacon/static-1.1676",
  "growth-payments-core": "/growth-payments-core/static-1.19571",
  "head-dlb": "/head-dlb/static-1.3234",
  "highcharts": "/highcharts/static-8.77",
  "history": "/history/static-4.47",
  "hs-promise-utils": "/hs-promise-utils/static-1.3739",
  "hs-test-utils": "/hs-test-utils/static-1.6238",
  "hub-http": "/hub-http/static-1.4502",
  "hubspot-apollo-client": "/hubspot-apollo-client/static-1.3091",
  "hubspot-dlb": "/hubspot-dlb/static-2.1055",
  "HubStyleTokens": "/HubStyleTokens/static-2.9765",
  "I18n": "/I18n/static-7.1341",
  "immer": "/immer/static-1.33",
  "immutable": "/immutable/static-2.19",
  "inbound-db-meta-service-client": "/inbound-db-meta-service-client/static-1.2313",
  "inbound-db-properties-service-client": "/inbound-db-properties-service-client/static-1.2507",
  "inbounddb-objects-service-types": "/inbounddb-objects-service-types/static-1.2689",
  "jasmine-immutable": "/jasmine-immutable/static-1.1267",
  "jasmine-runner": "/jasmine-runner/static-1.4639",
  "laboratory-lib": "/laboratory-lib/static-3.5524",
  "lodash": "/lodash/static-1.3",
  "marketing-event-attendance-cards-ui": "/marketing-event-attendance-cards-ui/static-1.3357",
  "marketplace-embed": "/marketplace-embed/static-1.14105",
  "marketplace-ui-client-types": "/marketplace-ui-client-types/static-1.9728",
  "object-builder-ui-client": "/object-builder-ui-client/static-1.39489",
  "onboarding-scopes": "/onboarding-scopes/static-1.4822",
  "onboarding-tours": "/onboarding-tours/static-1.13351",
  "payments-zero-states-lib": "/payments-zero-states-lib/static-1.12663",
  "pipeline-validation-client-types": "/pipeline-validation-client-types/static-1.2448",
  "PortalIdParser": "/PortalIdParser/static-2.263",
  "products-iframe-lib": "/products-iframe-lib/static-1.845",
  "products-ui-components": "/products-ui-components/static-1.33780",
  "property-management-iframe": "/property-management-iframe/static-1.6868",
  "quartz": "/quartz/static-1.4993",
  "quick-fetch": "/quick-fetch/static-1.2511",
  "raven": "/raven/static-3.3936",
  "react": "/react/static-7.147",
  "react-dlb": "/react-dlb/static-1.46",
  "react-dnd": "/react-dnd/static-4.51",
  "react-dnd-html5-backend": "/react-dnd-html5-backend/static-4.5",
  "react-redux": "/react-redux/static-7.16",
  "react-rhumb": "/react-rhumb/static-1.14856",
  "react-router-dom": "/react-router-dom/static-5.26",
  "react-utils": "/react-utils/static-2.3879",
  "reference-resolvers-lite": "/reference-resolvers-lite/static-1.6198",
  "reference-resolvers-lite-shared-msw-handlers": "/reference-resolvers-lite-shared-msw-handlers/static-1.6551",
  "reporting-data": "/reporting-data/static-1.59732",
  "reporting-dlb": "/reporting-dlb/static-1.52650",
  "reporting-testing-lib": "/reporting-testing-lib/static-1.1667",
  "reporting-visualizations": "/reporting-visualizations/static-1.51812",
  "sales-views-client-types": "/sales-views-client-types/static-1.2667",
  "self-service-api": "/self-service-api/static-1.8393",
  "settings-ui-lib": "/settings-ui-lib/static-1.10804",
  "signup-constants": "/signup-constants/static-1.15155",
  "styled-components": "/styled-components/static-2.40",
  "superstore": "/superstore/static-1.3036",
  "svh-onboarding-config-shared-lib": "/svh-onboarding-config-shared-lib/static-1.1288",
  "tinymce": "/tinymce/static-6.5",
  "transmute": "/transmute/static-2.29",
  "trial-components-library": "/trial-components-library/static-1.9961",
  "ui-addon-draggable": "/ui-addon-draggable/static-2.1191",
  "ui-addon-integrations-directory-panel": "/ui-addon-integrations-directory-panel/static-2.6227",
  "ui-addon-upgrades": "/ui-addon-upgrades/static-9.15246",
  "ui-components-test-utils": "/ui-components-test-utils/static-1.3905",
  "UIComponents": "/UIComponents/static-3.6714",
  "usage-tracker-core": "/usage-tracker-core/static-1.5588",
  "user-context": "/user-context/static-1.3408",
  "webpack-env": "/webpack-env/static-1.54",
  "wootric-nps": "/wootric-nps/static-1.5256",
  "account-and-billing-components": "/account-and-billing-components/static-1.15202",
  "account-and-billing-fintech-outages": "/account-and-billing-fintech-outages/static-3.13951",
  "accounting-extension-card-ui": "/accounting-extension-card-ui/static-1.29509",
  "accounting-integrations-ui-components": "/accounting-integrations-ui-components/static-1.4027",
  "ai-components-ui-library": "/ai-components-ui-library/static-1.4498",
  "apollo-link-hub-http": "/apollo-link-hub-http/static-2.3067",
  "attribution-sidebar-cards": "/attribution-sidebar-cards/static-1.37643",
  "BizOpsCrmUIComponents": "/BizOpsCrmUIComponents/static-1.38689",
  "call-widget-addon": "/call-widget-addon/static-2.25119",
  "calling-integration-sdk-support": "/calling-integration-sdk-support/static-1.23313",
  "calling-integration-timeline-event": "/calling-integration-timeline-event/static-1.11009",
  "calling-internal-common": "/calling-internal-common/static-1.29374",
  "calling-lifecycle-internal": "/calling-lifecycle-internal/static-1.56390",
  "calling-ui-library": "/calling-ui-library/static-1.62310",
  "card-biz-ops-customer-success-lib": "/card-biz-ops-customer-success-lib/static-1.69717",
  "card-biz-ops-domain-controls-lib": "/card-biz-ops-domain-controls-lib/static-1.69718",
  "card-biz-ops-related-contacts-lib": "/card-biz-ops-related-contacts-lib/static-1.69717",
  "card-crm-attribution-lib": "/card-crm-attribution-lib/static-1.47965",
  "card-deal-collaborators-lib": "/card-deal-collaborators-lib/static-1.30910",
  "card-deal-shared-view-lib": "/card-deal-shared-view-lib/static-1.61261",
  "card-engagement-attachments-lib": "/card-engagement-attachments-lib/static-1.66078",
  "card-gdpr-subscriptions-card-lib": "/card-gdpr-subscriptions-card-lib/static-1.40379",
  "card-integration-card-lib": "/card-integration-card-lib/static-1.66302",
  "card-linked-in-sales-navigator-lib": "/card-linked-in-sales-navigator-lib/static-1.33433",
  "card-lists-lib": "/card-lists-lib/static-1.64117",
  "card-past-conversations-lib": "/card-past-conversations-lib/static-1.31654",
  "card-payment-history-lib": "/card-payment-history-lib/static-1.29403",
  "card-playbooks-lib": "/card-playbooks-lib/static-1.56200",
  "card-preview-highlight-lib": "/card-preview-highlight-lib/static-1.68600",
  "card-profile-products-lib": "/card-profile-products-lib/static-1.49605",
  "card-profile-quotes-lib": "/card-profile-quotes-lib/static-1.76911",
  "card-properties-lib": "/card-properties-lib/static-1.36867",
  "card-sales-activities-timeline": "/card-sales-activities-timeline/static-1.30253",
  "card-target-account-lib": "/card-target-account-lib/static-1.65693",
  "card-website-activity-lib": "/card-website-activity-lib/static-1.66522",
  "chatspot-widget-iframe": "/chatspot-widget-iframe/static-1.13585",
  "collaboration-sidebar": "/collaboration-sidebar/static-1.50175",
  "commerce-billing-lib": "/commerce-billing-lib/static-1.13136",
  "commerce-subscription-cards-lib": "/commerce-subscription-cards-lib/static-1.24163",
  "commerce-subscription-lib": "/commerce-subscription-lib/static-1.29337",
  "composer-plugins": "/composer-plugins/static-1.64706",
  "conversations-thread-view-crm-events": "/conversations-thread-view-crm-events/static-1.27873",
  "copilot-toolkit": "/copilot-toolkit/static-1.4361",
  "credit-memos-iframe-lib": "/credit-memos-iframe-lib/static-1.4139",
  "crm_components": "/crm_components/static-3.85028",
  "crm_schema": "/crm_schema/static-3.85063",
  "crm_ui": "/crm_ui/static-5.84986",
  "crm_universal": "/crm_universal/static-1.19967",
  "crm-activity-creator-interaction-window": "/crm-activity-creator-interaction-window/static-1.38984",
  "crm-activity-creator-interactions-legacy": "/crm-activity-creator-interactions-legacy/static-1.29453",
  "crm-activity-creator-widgets": "/crm-activity-creator-widgets/static-1.45035",
  "crm-associations-table": "/crm-associations-table/static-1.34836",
  "crm-cards": "/crm-cards/static-1.37554",
  "crm-cards-sdk": "/crm-cards-sdk/static-1.36255",
  "crm-command-handler": "/crm-command-handler/static-1.28505",
  "crm-display-components": "/crm-display-components/static-1.18737",
  "crm-events-components": "/crm-events-components/static-1.53494",
  "crm-events-data": "/crm-events-data/static-1.53506",
  "crm-fe-perf": "/crm-fe-perf/static-1.21248",
  "crm-index-ui-toolbar": "/crm-index-ui-toolbar/static-1.1302",
  "crm-index-view-table-edit-columns-modal": "/crm-index-view-table-edit-columns-modal/static-1.15030",
  "crm-index-visualization-toolbar": "/crm-index-visualization-toolbar/static-1.1724",
  "crm-index-visualization-toolbar-test-utils": "/crm-index-visualization-toolbar-test-utils/static-1.1097",
  "crm-links": "/crm-links/static-1.4342",
  "crm-object-board": "/crm-object-board/static-1.20745",
  "crm-object-board-card": "/crm-object-board-card/static-1.10820",
  "crm-object-preview": "/crm-object-preview/static-1.19692",
  "crm-object-table": "/crm-object-table/static-1.15954",
  "crm-timeline": "/crm-timeline/static-1.81834",
  "crm-timeline-tasks": "/crm-timeline-tasks/static-1.30790",
  "cropperjs": "/cropperjs/static-1.10",
  "cssUtils": "/cssUtils/static-1.372",
  "customer-data-board": "/customer-data-board/static-1.18224",
  "customer-data-board-card": "/customer-data-board-card/static-1.18185",
  "customer-data-bulk-actions-container": "/customer-data-bulk-actions-container/static-1.14013",
  "customer-data-communicator": "/customer-data-communicator/static-1.38355",
  "customer-data-email": "/customer-data-email/static-1.14953",
  "customer-data-filters-ui": "/customer-data-filters-ui/static-1.31931",
  "customer-data-property-utils": "/customer-data-property-utils/static-1.6173",
  "customer-data-reference-ui-components": "/customer-data-reference-ui-components/static-1.11183",
  "customer-data-rte": "/customer-data-rte/static-1.27449",
  "customer-data-ui-utilities": "/customer-data-ui-utilities/static-1.7989",
  "deal-registration-ui": "/deal-registration-ui/static-1.28608",
  "deal-splits-cards-ui": "/deal-splits-cards-ui/static-1.37704",
  "deal-splits-sidebar": "/deal-splits-sidebar/static-1.37609",
  "draft-email-branding-plugin": "/draft-email-branding-plugin/static-2.18644",
  "draft-js": "/draft-js/static-5.37",
  "draft-plugins": "/draft-plugins/static-2.18409",
  "draft-signature-plugin": "/draft-signature-plugin/static-1.18425",
  "draft-smart-detections": "/draft-smart-detections/static-1.8443",
  "email-confirm-ui": "/email-confirm-ui/static-2.3861",
  "EmailSignatureEditor": "/EmailSignatureEditor/static-1.19029",
  "ExportDialog": "/ExportDialog/static-6.8641",
  "ExtensionInstallHelpers": "/ExtensionInstallHelpers/static-1.520",
  "file-manager-components": "/file-manager-components/static-1.16545",
  "FileManagerLib": "/FileManagerLib/static-1.32187",
  "flywheel-feedback-panel-components": "/flywheel-feedback-panel-components/static-1.5517",
  "foundations-assets": "/foundations-assets/static-1.3146",
  "framework-app-settings-features-lib": "/framework-app-settings-features-lib/static-1.3290",
  "frontend-preferences-client": "/frontend-preferences-client/static-1.6146",
  "getting-started-shared-tasks": "/getting-started-shared-tasks/static-1.9827",
  "graphql": "/graphql/static-1.56",
  "growth-data-modal": "/growth-data-modal/static-1.3424",
  "growth-feature-usage-components": "/growth-feature-usage-components/static-1.3177",
  "growth-feature-usage-data": "/growth-feature-usage-data/static-1.3395",
  "growth-onboarding-empty-states": "/growth-onboarding-empty-states/static-1.3331",
  "HeadJS": "/HeadJS/static-2.541",
  "hubspot-prosemirror": "/hubspot-prosemirror/static-1.12093",
  "hubspot-url-utils": "/hubspot-url-utils/static-1.2706",
  "HubStyle": "/HubStyle/static-2.10074",
  "icons": "/icons/static-2.589",
  "in-meeting-experience-ui-components": "/in-meeting-experience-ui-components/static-1.15283",
  "InboxConnectUtils": "/InboxConnectUtils/static-4.8916",
  "integration-settings-components": "/integration-settings-components/static-1.9289",
  "integrations-directory-panel-lib": "/integrations-directory-panel-lib/static-1.6797",
  "invoices-card-lib": "/invoices-card-lib/static-1.50053",
  "invoices-iframe-lib": "/invoices-iframe-lib/static-1.49980",
  "invoices-ui-lib": "/invoices-ui-lib/static-1.47922",
  "lead-tracking-lib": "/lead-tracking-lib/static-1.31681",
  "marketing-contacts-lib": "/marketing-contacts-lib/static-1.7389",
  "marketing-contacts-ui": "/marketing-contacts-ui/static-1.5820",
  "marketing-event-cards-ui": "/marketing-event-cards-ui/static-1.29754",
  "marketplace-ui-apps-core": "/marketplace-ui-apps-core/static-1.10860",
  "marketplace-ui-common": "/marketplace-ui-common/static-1.12324",
  "metrics-js": "/metrics-js/static-1.8013",
  "mobile-manifest-mixins": "/mobile-manifest-mixins/static-1.312",
  "native-integrations-shared-strings": "/native-integrations-shared-strings/static-1.6060",
  "nav-meta": "/nav-meta/static-1.24580",
  "object-comments-thread-lib": "/object-comments-thread-lib/static-1.4592",
  "onboarding-tours-client": "/onboarding-tours-client/static-1.2786",
  "orders-card-lib": "/orders-card-lib/static-1.15199",
  "panel-deal-registration-ai-summary-lib": "/panel-deal-registration-ai-summary-lib/static-1.20197",
  "partner-shared-view-ui": "/partner-shared-view-ui/static-1.40537",
  "playbooks-modal": "/playbooks-modal/static-1.73374",
  "playlists-lib": "/playlists-lib/static-1.5763",
  "products-highlight-card-lib": "/products-highlight-card-lib/static-1.11545",
  "property-translator": "/property-translator/static-1.3668",
  "quartz-core": "/quartz-core/static-1.4212",
  "quotes-ui-components": "/quotes-ui-components/static-1.43029",
  "quotes-ui-lib": "/quotes-ui-lib/static-1.72103",
  "react-beautiful-dnd": "/react-beautiful-dnd/static-1.13",
  "react-colorpicker": "/react-colorpicker/static-2.8489",
  "react-immutable-render-mixin": "/react-immutable-render-mixin/static-1.9",
  "react-select-plus": "/react-select-plus/static-1.65",
  "recent-activities-card": "/recent-activities-card/static-1.51358",
  "redux": "/redux/static-4.16",
  "redux-thunk": "/redux-thunk/static-2.43",
  "redux-toolkit": "/redux-toolkit/static-1.7",
  "reference-resolvers": "/reference-resolvers/static-1.6398",
  "reporting-action-components": "/reporting-action-components/static-1.34230",
  "reporting-crm-object-table": "/reporting-crm-object-table/static-1.906",
  "reporting-enablement": "/reporting-enablement/static-1.15017",
  "reporting-ui-components": "/reporting-ui-components/static-2.57015",
  "reselect": "/reselect/static-2.16",
  "rich-text-lib": "/rich-text-lib/static-1.16590",
  "rpc-client-utils": "/rpc-client-utils/static-1.3001",
  "SalesContentIndexUI": "/SalesContentIndexUI/static-3.6193",
  "salesforce-sync-card-ui": "/salesforce-sync-card-ui/static-1.7150",
  "SalesTemplateEditor": "/SalesTemplateEditor/static-3.25249",
  "sanitize-text": "/sanitize-text/static-1.6454",
  "sequences-lib": "/sequences-lib/static-1.5033",
  "SharedI18nStrings": "/SharedI18nStrings/static-1.160",
  "subscriptions-components": "/subscriptions-components/static-1.39677",
  "svh-conversations-settings-lib": "/svh-conversations-settings-lib/static-1.1290",
  "tasks-lib": "/tasks-lib/static-1.30864",
  "timezone-utils": "/timezone-utils/static-2.3543",
  "transcript-sidebar": "/transcript-sidebar/static-1.60110",
  "trellis-ecosystem": "/trellis-ecosystem/static-1.3762",
  "ui-addon-avatars": "/ui-addon-avatars/static-2.7692",
  "ui-addon-form-validation": "/ui-addon-form-validation/static-1.9291",
  "ui-addon-i18n": "/ui-addon-i18n/static-1.9161",
  "ui-addon-iframeable": "/ui-addon-iframeable/static-1.7163",
  "ui-addon-opt": "/ui-addon-opt/static-4.6970",
  "ui-addon-react-router-dom": "/ui-addon-react-router-dom/static-1.7866",
  "ui-addon-scriptloader": "/ui-addon-scriptloader/static-1.10613",
  "ui-addon-teams": "/ui-addon-teams/static-1.18960",
  "ui-asset-management-lib": "/ui-asset-management-lib/static-1.8306",
  "ui-business-units-lib": "/ui-business-units-lib/static-1.7114",
  "ui-gdpr-components": "/ui-gdpr-components/static-1.8511",
  "ui-shepherd-react": "/ui-shepherd-react/static-3.8227",
  "ui-universal-auth": "/ui-universal-auth/static-1.6976",
  "usage-tracker": "/usage-tracker/static-1.5738",
  "usage-tracker-container": "/usage-tracker-container/static-1.5728",
  "atom": "/atom/static-1.3574",
  "hs-lodash": "/hs-lodash/static-4.40",
  "planout": "/planout/static-5.12",
  "react-immutable-proptypes": "/react-immutable-proptypes/static-2.8",
  "react-input-autosize": "/react-input-autosize/static-2.17",
  "sanitize": "/sanitize/static-1.2629",
  "hs-promise-rejection-tracking": "/hs-promise-rejection-tracking/static-1.3563",
  "raven-hubspot": "/raven-hubspot/static-1.4243",
  "classnames": "/classnames/static-2.10",
  "hoist-non-react-statics": "/hoist-non-react-statics/static-3.9",
  "bend-plugin-trellis-migration": "/bend-plugin-trellis-migration/static-1.1987",
  "moment": "/moment/static-3.26",
  "react-dom": "/react-dom/static-7.85",
  "bend-plugin-quartz": "/bend-plugin-quartz/static-1.1270",
  "quartz-webpack": "/quartz-webpack/static-1.1217",
  "ably": "/ably/static-1.18",
  "calling-orchestration-schema": "/calling-orchestration-schema/static-1.28978",
  "calling-global-api": "/calling-global-api/static-1.55008",
  "campaigns-lib": "/campaigns-lib/static-1.20339",
  "card-payment-highlight-lib": "/card-payment-highlight-lib/static-1.29537",
  "customer-data-tracking": "/customer-data-tracking/static-1.5084",
  "payment-link-components": "/payment-link-components/static-1.16569",
  "payments-embed-points-lib": "/payments-embed-points-lib/static-1.8108",
  "persist-promise": "/persist-promise/static-1.2014",
  "PatternValidationJS": "/PatternValidationJS/static-1.437",
  "usage-tracker-session-replay": "/usage-tracker-session-replay/static-1.2954",
  "utility-belt": "/utility-belt/static-1.847",
  "products-ui-components-shared-msw-handlers": "/products-ui-components-shared-msw-handlers/static-1.6790",
  "hs-story-utils": "/hs-story-utils/static-1.7575",
  "msw": "/msw/static-1.39",
  "payments-enrollment-embed-lib": "/payments-enrollment-embed-lib/static-1.15990",
  "StyleGuideUI": "/StyleGuideUI/static-3.444",
  "ui-images": "/ui-images/static-2.784",
  "cv-backend-services": "/cv-backend-services/static-1.1007",
  "growth-onboarding-confetti": "/growth-onboarding-confetti/static-1.1376",
  "payments-post-enroll-local-storage-lib": "/payments-post-enroll-local-storage-lib/static-1.3338",
  "prosemirror": "/prosemirror/static-1.13",
  "qrcode-generator": "/qrcode-generator/static-1.41",
  "react-dnd-compat": "/react-dnd-compat/static-1.2842",
  "adobe-sign-cards-lib": "/adobe-sign-cards-lib/static-1.10930",
  "ai-addon-copilot-preview": "/ai-addon-copilot-preview/static-1.3710",
  "automation-ui-crm-card-workflows-invoker": "/automation-ui-crm-card-workflows-invoker/static-1.3379",
  "buyer-intent-card": "/buyer-intent-card/static-1.14317",
  "card-call-summaries-lib": "/card-call-summaries-lib/static-1.28297",
  "card-company-summary-lib": "/card-company-summary-lib/static-1.11835",
  "card-customer-spend-trends-lib": "/card-customer-spend-trends-lib/static-1.19120",
  "card-flywheel-activity-history-lib": "/card-flywheel-activity-history-lib/static-1.396",
  "card-flywheel-company-overview-lib": "/card-flywheel-company-overview-lib/static-1.9425",
  "card-flywheel-high-intent-associated-contacts-lib": "/card-flywheel-high-intent-associated-contacts-lib/static-1.9425",
  "card-guest-access-management-lib": "/card-guest-access-management-lib/static-1.1279",
  "flywheel-growth-plans-crm-card": "/flywheel-growth-plans-crm-card/static-1.417",
  "card-guided-execution-activities": "/card-guided-execution-activities/static-1.2346",
  "card-knowledge-base-lib": "/card-knowledge-base-lib/static-1.6385",
  "card-lead-insights": "/card-lead-insights/static-1.6941",
  "card-lead-qualification-lib": "/card-lead-qualification-lib/static-1.23181",
  "card-object-highlight-lib": "/card-object-highlight-lib/static-1.62",
  "card-object-summary-lib": "/card-object-summary-lib/static-1.2225",
  "card-other-tickets-lib": "/card-other-tickets-lib/static-1.14660",
  "card-partner-client-portal-usage-outcomes-lib": "/card-partner-client-portal-usage-outcomes-lib/static-1.23264",
  "card-partner-client-unified-usage-score-lib": "/card-partner-client-unified-usage-score-lib/static-1.17629",
  "card-tasks-timeline-lib": "/card-tasks-timeline-lib/static-1.9250",
  "card-ticket-summary-lib": "/card-ticket-summary-lib/static-1.11097",
  "crm-actions": "/crm-actions/static-1.4249",
  "crm-associations-pivot": "/crm-associations-pivot/static-1.32966",
  "crm-clv-report": "/crm-clv-report/static-1.1624",
  "crm-data-highlights": "/crm-data-highlights/static-1.35374",
  "crm-events-viz-cards": "/crm-events-viz-cards/static-1.34661",
  "crm-events-viz-totals": "/crm-events-viz-totals/static-1.26214",
  "crm-extension": "/crm-extension/static-1.34695",
  "crm-pipeline-approvals-lib": "/crm-pipeline-approvals-lib/static-1.17460",
  "crm-properties-list": "/crm-properties-list/static-1.32012",
  "crm-property-history": "/crm-property-history/static-1.10072",
  "crm-quick-actions": "/crm-quick-actions/static-1.11522",
  "crm-relative-timeline": "/crm-relative-timeline/static-1.11950",
  "crm-report": "/crm-report/static-1.35581",
  "crm-simple-deadline": "/crm-simple-deadline/static-1.12169",
  "crm-stage-tracker": "/crm-stage-tracker/static-1.30546",
  "crm-statistics": "/crm-statistics/static-1.24590",
  "customer-overview-card-lib": "/customer-overview-card-lib/static-1.2858",
  "customer-success-contacts-card-lib": "/customer-success-contacts-card-lib/static-1.11188",
  "datawell-report-crm-card": "/datawell-report-crm-card/static-1.12673",
  "deal-summary-components": "/deal-summary-components/static-1.13744",
  "docusign-cards-lib": "/docusign-cards-lib/static-1.20519",
  "guided-actions-card": "/guided-actions-card/static-1.7625",
  "guided-selling-stage-tracker-card": "/guided-selling-stage-tracker-card/static-1.4083",
  "health-score-card-lib": "/health-score-card-lib/static-1.14471",
  "help-desk-insights-lib-crm-cards": "/help-desk-insights-lib-crm-cards/static-1.16340",
  "intelligence-overview-card": "/intelligence-overview-card/static-1.8149",
  "intelligence-overview-lib": "/intelligence-overview-lib/static-1.7040",
  "invoices-history-card-lib": "/invoices-history-card-lib/static-1.24337",
  "lead-scores-card": "/lead-scores-card/static-1.10635",
  "legacy-sidebar-card-lib": "/legacy-sidebar-card-lib/static-1.27463",
  "payment-schedule-card-lib": "/payment-schedule-card-lib/static-1.21525",
  "playbooks-card": "/playbooks-card/static-1.36085",
  "predictive-scores-card": "/predictive-scores-card/static-1.23652",
  "process-guide-cards": "/process-guide-cards/static-1.2985",
  "products-cards-lib": "/products-cards-lib/static-1.2854",
  "purchase-history-lib": "/purchase-history-lib/static-1.13885",
  "customer-data-properties-shared-msw-handlers": "/customer-data-properties-shared-msw-handlers/static-1.5735",
  "ts-schema": "/ts-schema/static-1.2701",
  "framework-builder-read-service-client": "/framework-builder-read-service-client/static-1.2627",
  "hub-http-shared-msw-handlers": "/hub-http-shared-msw-handlers/static-1.6405",
  "multi-currency-client-types": "/multi-currency-client-types/static-1.2424",
  "fast-json-stable-stringify": "/fast-json-stable-stringify/static-1.4",
  "csstype": "/csstype/static-1.38",
  "jasmine": "/jasmine/static-4.2622",
  "usage-tracker-public": "/usage-tracker-public/static-1.5549",
  "content-assistance-lib": "/content-assistance-lib/static-1.5664",
  "crm-record-access-management-lib": "/crm-record-access-management-lib/static-1.18916",
  "customer-data-content": "/customer-data-content/static-1.23449",
  "draft-content-plugins": "/draft-content-plugins/static-1.22762",
  "draft-convert": "/draft-convert/static-2.31",
  "draft-extend": "/draft-extend/static-2.46",
  "enrichment-properties-lib": "/enrichment-properties-lib/static-1.7866",
  "FireAlarmUi": "/FireAlarmUi/static-1.3207",
  "flux-actions": "/flux-actions/static-1.260",
  "marketing-contacts-client": "/marketing-contacts-client/static-1.5821",
  "pipeline-governance-client-types": "/pipeline-governance-client-types/static-1.2714",
  "prospecting-agent-lib": "/prospecting-agent-lib/static-1.4726",
  "react-virtualized": "/react-virtualized/static-2.71",
  "subscriptions-client": "/subscriptions-client/static-1.39917",
  "surveymonkey-crm-card": "/surveymonkey-crm-card/static-1.33753",
  "task-forms-lib": "/task-forms-lib/static-1.33679",
  "ui-coaching-tips": "/ui-coaching-tips/static-1.20308",
  "avatar-components": "/avatar-components/static-1.667",
  "autolinker": "/autolinker/static-3.11",
  "conditional-properties-service-client": "/conditional-properties-service-client/static-1.2508",
  "google-libphonenumber": "/google-libphonenumber/static-1.9",
  "calling-error-reporting": "/calling-error-reporting/static-1.29380",
  "card-subscription-highlight-lib": "/card-subscription-highlight-lib/static-1.31761",
  "invoices-highlight-card-lib": "/invoices-highlight-card-lib/static-1.47909",
  "orders-highlight-card-lib": "/orders-highlight-card-lib/static-1.15482",
  "project-storage": "/project-storage/static-1.2981",
  "quotes-highlight-card-lib": "/quotes-highlight-card-lib/static-1.63392",
  "crm-export-dialog": "/crm-export-dialog/static-1.4546",
  "customer-data-filters": "/customer-data-filters/static-1.45745",
  "FormUrlGenerator": "/FormUrlGenerator/static-2.2994",
  "testing-library": "/testing-library/static-1.118",
  "academy-common-lib": "/academy-common-lib/static-1.8459",
  "bend-plugin-foundations-components": "/bend-plugin-foundations-components/static-1.1630",
  "floating-ui": "/floating-ui/static-1.26",
  "foundations-theming-specialty": "/foundations-theming-specialty/static-1.221",
  "framer-motion": "/framer-motion/static-1.38",
  "react-aria": "/react-aria/static-1.36",
  "tanstack-table": "/tanstack-table/static-1.23",
  "ui-fonts": "/ui-fonts/static-1.329",
  "bend-plugin-foundations-theming": "/bend-plugin-foundations-theming/static-1.987",
  "foundations-theming-base": "/foundations-theming-base/static-1.1489",
  "customer-data-associations": "/customer-data-associations/static-1.5452",
  "growth-onboarding-feedback-components": "/growth-onboarding-feedback-components/static-1.4717",
  "commerce-analytics-service-client": "/commerce-analytics-service-client/static-1.2059",
  "hs-test-utils-bend-plugin": "/hs-test-utils-bend-plugin/static-1.1349",
  "i18n-data": "/i18n-data/static-1.193",
  "moment-timezone": "/moment-timezone/static-5.51",
  "magpie-lib": "/magpie-lib/static-1.3893",
  "marketplace-ui-details": "/marketplace-ui-details/static-1.2225",
  "navigation-components": "/navigation-components/static-1.12943",
  "ui-shepherd-tracker": "/ui-shepherd-tracker/static-1.5608",
  "property-description-translator": "/property-description-translator/static-1.2130",
  "quartz-core-utils": "/quartz-core-utils/static-1.1860",
  "reporting-client-types": "/reporting-client-types/static-1.1609",
  "redux-observable": "/redux-observable/static-1.11",
  "ReduxMessenger": "/ReduxMessenger/static-2.8723",
  "rxjs": "/rxjs/static-5.10",
  "underscore": "/underscore/static-1.8",
  "conversations-async-data": "/conversations-async-data/static-2.5930",
  "conversations-error-reporting": "/conversations-error-reporting/static-1.7120",
  "conversations-http": "/conversations-http/static-1.3038",
  "conversations-internal-schema": "/conversations-internal-schema/static-1.10873",
  "conversations-message-history": "/conversations-message-history/static-1.9301",
  "routing-ui": "/routing-ui/static-1.14164",
  "salesImages": "/salesImages/static-1.495",
  "trials-service-types": "/trials-service-types/static-1.2370",
  "react-flip-move": "/react-flip-move/static-1.44",
  "feature-store-service-types": "/feature-store-service-types/static-1.2962",
  "growth-monetization-service-types": "/growth-monetization-service-types/static-1.2969",
  "upgrade-management-service-types": "/upgrade-management-service-types/static-1.2953",
  "getting-started-shared-tasks-store": "/getting-started-shared-tasks-store/static-1.8945",
  "final-form": "/final-form/static-1.37",
  "fintech-outages-service-client-types": "/fintech-outages-service-client-types/static-1.10906",
  "subscription-experience-data-types": "/subscription-experience-data-types/static-1.9071",
  "transactions-exp-service-client-types": "/transactions-exp-service-client-types/static-1.10902",
  "conversations-skeleton-state": "/conversations-skeleton-state/static-1.5660",
  "integrations-lib": "/integrations-lib/static-1.9190",
  "chatspot-client-types": "/chatspot-client-types/static-1.7775",
  "chatspot-core": "/chatspot-core/static-1.13589",
  "ContentUtils": "/ContentUtils/static-1.61379",
  "sassPrefix": "/sassPrefix/static-1.127",
  "report-customization-components": "/report-customization-components/static-1.7122",
  "reporting-snowflake": "/reporting-snowflake/static-1.48358",
  "activity-history-lib": "/activity-history-lib/static-1.217",
  "assisted-buying-components": "/assisted-buying-components/static-1.5233",
  "bet-customer-success-shared-ui": "/bet-customer-success-shared-ui/static-1.10818",
  "domain-review-history-lib": "/domain-review-history-lib/static-1.296",
  "industries-core": "/industries-core/static-1.5008",
  "calling-client-interface": "/calling-client-interface/static-1.67549",
  "calling-cross-tab-library": "/calling-cross-tab-library/static-1.17313",
  "calling-integration-cross-tab": "/calling-integration-cross-tab/static-1.15083",
  "calling-lifecycle-messages": "/calling-lifecycle-messages/static-1.48687",
  "calling-lifecycle-usage-tracker": "/calling-lifecycle-usage-tracker/static-1.4164",
  "calling-usage-tracker": "/calling-usage-tracker/static-1.4751",
  "conversations-prop-types": "/conversations-prop-types/static-1.5694",
  "shared-worker-versioning": "/shared-worker-versioning/static-1.9301",
  "universal-associations-select": "/universal-associations-select/static-1.8998",
  "hubspot-prosemirror-plugins": "/hubspot-prosemirror-plugins/static-1.12086",
  "redux-actions": "/redux-actions/static-3.7",
  "share-transcript-modal": "/share-transcript-modal/static-1.49753",
  "twilio-voice-sdk": "/twilio-voice-sdk/static-1.48",
  "worker-connection-library": "/worker-connection-library/static-1.9611",
  "SafeStorage": "/SafeStorage/static-1.2674",
  "ui-partner-confirmation-links-components": "/ui-partner-confirmation-links-components/static-1.19962",
  "FileManagerCore": "/FileManagerCore/static-1.32045",
  "ui-extensions-canvas-renderer": "/ui-extensions-canvas-renderer/static-1.13152",
  "crm-activity-creator-data": "/crm-activity-creator-data/static-1.39529",
  "multi-account-crm-panel-lib": "/multi-account-crm-panel-lib/static-1.10163",
  "sequences-crm-lib": "/sequences-crm-lib/static-1.20862",
  "quotes-modal-lib": "/quotes-modal-lib/static-1.94057",
  "call-timeline-event": "/call-timeline-event/static-1.48316",
  "crm-events": "/crm-events/static-1.53501",
  "crm-meetings-components-lib": "/crm-meetings-components-lib/static-1.19623",
  "svh-tickets-lib": "/svh-tickets-lib/static-1.11791",
  "recording-review-components-lib": "/recording-review-components-lib/static-1.24174",
  "composer-data": "/composer-data/static-1.24096",
  "conversations-inbox-message-history": "/conversations-inbox-message-history/static-1.27756",
  "conversations-infrastructure": "/conversations-infrastructure/static-1.7168",
  "conversations-internal-pub-sub": "/conversations-internal-pub-sub/static-1.14233",
  "conversations-platform": "/conversations-platform/static-1.2757",
  "conversations-thread-data": "/conversations-thread-data/static-1.61208",
  "crm-events-viz-core": "/crm-events-viz-core/static-1.27005",
  "hubspotter-http": "/hubspotter-http/static-1.3088",
  "react-transition-group": "/react-transition-group/static-1.7",
  "ui-addon-conversations-settings": "/ui-addon-conversations-settings/static-2.25981",
  "ui-suspension-banners-lib": "/ui-suspension-banners-lib/static-1.4673",
  "zorse-crm-components-lib": "/zorse-crm-components-lib/static-1.5260",
  "crm-activity-creator-interactions": "/crm-activity-creator-interactions/static-1.38256",
  "framework-scoring-history-panel-lib": "/framework-scoring-history-panel-lib/static-1.8937",
  "MeetingsLib": "/MeetingsLib/static-2.51862",
  "hub-http-contrib": "/hub-http-contrib/static-1.1459",
  "task-queues": "/task-queues/static-1.26551",
  "ui-addon-video-player": "/ui-addon-video-player/static-1.7038",
  "card-past-feedback-lib": "/card-past-feedback-lib/static-1.34615",
  "location-customization-utils-lib": "/location-customization-utils-lib/static-1.2382",
  "all-properties-panel-lib": "/all-properties-panel-lib/static-1.735",
  "crm-events-viz-timeline": "/crm-events-viz-timeline/static-1.34669",
  "customer-data-modals": "/customer-data-modals/static-1.2966",
  "merge-modal-lib": "/merge-modal-lib/static-1.4778",
  "predictive-scores-panel": "/predictive-scores-panel/static-1.22654",
  "property-history-panel": "/property-history-panel/static-1.17985",
  "crm-source-interpretation-lib": "/crm-source-interpretation-lib/static-1.3525",
  "partner-shared-messages-lib": "/partner-shared-messages-lib/static-1.11333",
  "ql-visibility-lib": "/ql-visibility-lib/static-1.2364",
  "redux-mock-store": "/redux-mock-store/static-1.8",
  "automation-platform-service-types": "/automation-platform-service-types/static-1.1785",
  "sales-execution-components": "/sales-execution-components/static-1.6278",
  "credit-memos-highlight-card-lib": "/credit-memos-highlight-card-lib/static-1.3492",
  "breeze-intelligence-kit": "/breeze-intelligence-kit/static-1.3422",
  "policy-lib": "/policy-lib/static-1.5065",
  "analytics_js": "/analytics_js/static-1.2871",
  "blueimp-md5": "/blueimp-md5/static-1.8",
  "calling-cross-tab-messaging": "/calling-cross-tab-messaging/static-1.17311",
  "feedback-schema": "/feedback-schema/static-1.46292",
  "forms-utils-lib": "/forms-utils-lib/static-1.9267",
  "FormsCommonComponents": "/FormsCommonComponents/static-1.79122",
  "integrations-tracking-lib": "/integrations-tracking-lib/static-1.3660",
  "MeetingsBase": "/MeetingsBase/static-1.53452",
  "outpost": "/outpost/static-1.2517",
  "partner-poi-timeline-event": "/partner-poi-timeline-event/static-1.32138",
  "qualified-leads-embedded-lib": "/qualified-leads-embedded-lib/static-1.40176",
  "quotes-crm-events-lib": "/quotes-crm-events-lib/static-1.35480",
  "react-table": "/react-table/static-1.15",
  "sales-clients-common": "/sales-clients-common/static-1.43664",
  "sequences-client-types-lib": "/sequences-client-types-lib/static-1.4889",
  "sequences-crm-events-lib": "/sequences-crm-events-lib/static-1.20668",
  "settings-ui-nav": "/settings-ui-nav/static-2.8286",
  "social-components-lib": "/social-components-lib/static-1.27246",
  "ui-addon-sales-email": "/ui-addon-sales-email/static-1.3478",
  "ui-tour-react": "/ui-tour-react/static-1.10177",
  "urlinator": "/urlinator/static-1.2830",
  "outreach-assistant-email-generation": "/outreach-assistant-email-generation/static-1.1376",
  "quotes-client-types": "/quotes-client-types/static-1.29468",
  "sales-email-signature-service-client": "/sales-email-signature-service-client/static-1.2280",
  "customer-data-filters-ui-msw-helpers": "/customer-data-filters-ui-msw-helpers/static-1.14363",
  "signup-ui-lego-core": "/signup-ui-lego-core/static-1.17166",
  "viral-links-lib": "/viral-links-lib/static-1.5063",
  "media-bridge-lib": "/media-bridge-lib/static-1.15827",
  "video-data-lib": "/video-data-lib/static-1.27557",
  "FileManagerImages": "/FileManagerImages/static-1.29696",
  "hub-http-janus": "/hub-http-janus/static-1.611",
  "trellis-story-utils": "/trellis-story-utils/static-1.2803",
  "knowledge-content-types": "/knowledge-content-types/static-1.7343",
  "ui-addon-emoji-picker": "/ui-addon-emoji-picker/static-1.8176",
  "in-meeting-experience-client-types": "/in-meeting-experience-client-types/static-1.11982",
  "content-embed-lib": "/content-embed-lib/static-1.5446",
  "crm-record-cards-service-types": "/crm-record-cards-service-types/static-1.2387",
  "remote-ui": "/remote-ui/static-1.37",
  "ui-extensions": "/ui-extensions/static-1.13244",
  "ui-extensions-remote-renderer": "/ui-extensions-remote-renderer/static-1.10837",
  "universal-page-editor-lib": "/universal-page-editor-lib/static-1.1211",
  "developer-experience-shared-components": "/developer-experience-shared-components/static-1.8264",
  "immutable-less": "/immutable-less/static-1.2838",
  "ui-extensibility-client-types": "/ui-extensibility-client-types/static-1.2558",
  "react-window": "/react-window/static-1.13",
  "call-summary": "/call-summary/static-1.29702",
  "markdown-it": "/markdown-it/static-1.6",
  "hubspotter-http-shared-msw-handlers": "/hubspotter-http-shared-msw-handlers/static-1.6403",
  "platform-navigation-bootstrap": "/platform-navigation-bootstrap/static-1.10478",
  "dashboard-lib": "/dashboard-lib/static-1.73669",
  "share-with-third-party-component-lib": "/share-with-third-party-component-lib/static-1.6885",
  "data-quality-ui-library": "/data-quality-ui-library/static-1.6022",
  "html-to-image": "/html-to-image/static-1.27",
  "reporting-plugins": "/reporting-plugins/static-1.5494",
  "reporting-reports": "/reporting-reports/static-1.59421",
  "data-token-picker": "/data-token-picker/static-1.13179",
  "content-permissions-service-types-lib": "/content-permissions-service-types-lib/static-1.2720",
  "sales-templates-service-types-lib": "/sales-templates-service-types-lib/static-1.2720",
  "sequences-personalization-token-plugin": "/sequences-personalization-token-plugin/static-1.6243",
  "sequences-smart-detections-plugin": "/sequences-smart-detections-plugin/static-1.5956",
  "permission-components": "/permission-components/static-1.3625",
  "campaigns-build-lib": "/campaigns-build-lib/static-1.5250",
  "marketing-platform-lib": "/marketing-platform-lib/static-1.4911",
  "growth-onboarding-reliability": "/growth-onboarding-reliability/static-1.3412",
  "sales-checkout-service-client": "/sales-checkout-service-client/static-1.2071",
  "amplitude-session-replay-browser": "/amplitude-session-replay-browser/static-1.6",
  "stripe-embedded-components": "/stripe-embedded-components/static-1.4362",
  "integrations-error-boundary-lib": "/integrations-error-boundary-lib/static-1.6604",
  "ai-settings-ui-library": "/ai-settings-ui-library/static-1.5121",
  "automation-enrollment-service-types": "/automation-enrollment-service-types/static-1.2230",
  "crm-cards-test-utils": "/crm-cards-test-utils/static-1.36104",
  "renewal-center-service-types": "/renewal-center-service-types/static-1.2464",
  "submissions-lib": "/submissions-lib/static-1.39271",
  "ui-forms-components": "/ui-forms-components/static-1.7262",
  "portal-details-components": "/portal-details-components/static-1.11972",
  "ui-extensions-plugin-flywheel": "/ui-extensions-plugin-flywheel/static-1.7779",
  "ui-product-approvals": "/ui-product-approvals/static-1.22699",
  "customer-success-client-types": "/customer-success-client-types/static-1.12801",
  "sales-enablement-lib": "/sales-enablement-lib/static-1.9811",
  "sales-leader-insights-components-lib": "/sales-leader-insights-components-lib/static-1.11789",
  "guided-actions-lib": "/guided-actions-lib/static-1.12495",
  "framework-scoring-client-types": "/framework-scoring-client-types/static-1.9989",
  "fsm": "/fsm/static-1.1971",
  "card-bet-associated-companies-lib": "/card-bet-associated-companies-lib/static-1.69696",
  "card-bet-deal-support-requests-lib": "/card-bet-deal-support-requests-lib/static-1.60438",
  "card-bet-quotes-lib": "/card-bet-quotes-lib/static-1.69703",
  "card-deal-splits-lib": "/card-deal-splits-lib/static-1.37090",
  "card-flywheel-ql-summary-lib": "/card-flywheel-ql-summary-lib/static-1.38584",
  "card-flywheel-recent-conversions-lib": "/card-flywheel-recent-conversions-lib/static-1.38585",
  "card-invoices-lib": "/card-invoices-lib/static-1.48887",
  "card-marketing-event-about-lib": "/card-marketing-event-about-lib/static-1.48669",
  "card-marketing-event-activity-lib": "/card-marketing-event-activity-lib/static-1.48668",
  "card-prospecting-notes": "/card-prospecting-notes/static-1.30253",
  "card-qualified-leads-lib": "/card-qualified-leads-lib/static-1.69859",
  "card-sfdcsync-lib": "/card-sfdcsync-lib/static-1.48739",
  "card-workflows-lib": "/card-workflows-lib/static-1.65864",
  "integrations-sync-card-ui": "/integrations-sync-card-ui/static-1.19844",
  "partner-poi-crm-card": "/partner-poi-crm-card/static-1.12109",
  "recording-preview-card": "/recording-preview-card/static-1.9525",
  "ui-sales-order-wizard-card": "/ui-sales-order-wizard-card/static-1.24809",
  "predictive-scores-lib-components": "/predictive-scores-lib-components/static-1.21048",
  "process-guide-chirp": "/process-guide-chirp/static-1.2816",
  "prospecting-agent-client-types": "/prospecting-agent-client-types/static-1.21849",
  "deep-diff": "/deep-diff/static-1.5",
  "academy-service-client": "/academy-service-client/static-1.2542",
  "idb-keyval": "/idb-keyval/static-1.18",
  "magpie-types": "/magpie-types/static-1.3353",
  "simple-logging-lib": "/simple-logging-lib/static-1.1326",
  "marketplace-ui-reviews": "/marketplace-ui-reviews/static-1.12284",
  "marketplace-ui-tracking": "/marketplace-ui-tracking/static-1.6498",
  "cms-field-types": "/cms-field-types/static-1.3058",
  "content-icons-ui": "/content-icons-ui/static-1.1841",
  "reporting-datasets-permissions-lib": "/reporting-datasets-permissions-lib/static-1.5214",
  "fintech-buying-service-clients": "/fintech-buying-service-clients/static-1.2162",
  "account-and-billing-contacts-usage": "/account-and-billing-contacts-usage/static-2.16659",
  "signup-ui-full-screen-search": "/signup-ui-full-screen-search/static-1.9635",
  "crm-pipeline-events-ui": "/crm-pipeline-events-ui/static-1.20434",
  "conversations-calling-message": "/conversations-calling-message/static-1.52090",
  "conversations-routing-lib": "/conversations-routing-lib/static-1.4468",
  "conversations-visibility-tools": "/conversations-visibility-tools/static-1.4037",
  "data-ops-fullstory": "/data-ops-fullstory/static-1.3581",
  "re-reselect": "/re-reselect/static-1.4",
  "signup-ui-url-generator": "/signup-ui-url-generator/static-2.6289",
  "usage-tracker-anonymous": "/usage-tracker-anonymous/static-1.4155",
  "usage-tracker-multi": "/usage-tracker-multi/static-1.4152",
  "automation-ui-core": "/automation-ui-core/static-2.14699",
  "automation-ui-permissions": "/automation-ui-permissions/static-1.13061",
  "forms-ai-lib": "/forms-ai-lib/static-1.1584",
  "react-tinymce": "/react-tinymce/static-1.48872",
  "SharedLegalStrings": "/SharedLegalStrings/static-1.1264",
  "tinymce-config": "/tinymce-config/static-2.47998",
  "meetings-client-types": "/meetings-client-types/static-1.2412",
  "messaging-types-lib": "/messaging-types-lib/static-1.38117",
  "emoji-regex": "/emoji-regex/static-1.7",
  "apps-service-types": "/apps-service-types/static-1.2639",
  "oauth-service-types": "/oauth-service-types/static-1.2570",
  "platform-infra-nav-components": "/platform-infra-nav-components/static-1.6219",
  "campaign-roi-lib": "/campaign-roi-lib/static-1.755",
  "stripe-connect-js": "/stripe-connect-js/static-1.34",
  "customer-data-sidebar-test-utils": "/customer-data-sidebar-test-utils/static-1.33553",
  "form-builder-ui": "/form-builder-ui/static-1.7275",
  "user-configuration-lib": "/user-configuration-lib/static-1.22334",
  "ui-deal-management-components-lib": "/ui-deal-management-components-lib/static-1.14317",
  "automation-ui-routing": "/automation-ui-routing/static-1.14123",
  "automation-ui-source-apps": "/automation-ui-source-apps/static-1.11845",
  "tinymce-themes": "/tinymce-themes/static-1.49966",
  "interframe": "/interframe/static-3.3053",
  "tinymce-data": "/tinymce-data/static-1.34081",
  "tinymce-plugins": "/tinymce-plugins/static-1.51112",
  "ContentData": "/ContentData/static-1.61456",
  "marketing-email-service-types": "/marketing-email-service-types/static-1.1198",
  "layout-dnd-components": "/layout-dnd-components/static-1.10114",
  "layout-dnd-utils": "/layout-dnd-utils/static-1.9089",
  "app-users-service-client": "/app-users-service-client/static-1.3132",
  "framework-listing-lib": "/framework-listing-lib/static-2.20183",
  "mini-checkout-client": "/mini-checkout-client/static-1.22941",
  "onboarding-utils": "/onboarding-utils/static-1.3559",
  "ui-coaching-tips-shared-config": "/ui-coaching-tips-shared-config/static-1.20294",
  "NamespacedHubStyle": "/NamespacedHubStyle/static-2.7787",
  "codemirror": "/codemirror/static-5.67",
  "react-codemirror": "/react-codemirror/static-1.8849",
  "layout-data-lib": "/layout-data-lib/static-1.7414",
  "app-users-service-types": "/app-users-service-types/static-1.2538",
  "framework-listing-lib-shared-msw-handlers": "/framework-listing-lib-shared-msw-handlers/static-1.6296",
  "touchless-buying-components": "/touchless-buying-components/static-1.2658",
  "merchandise-lib": "/merchandise-lib/static-1.219",
  "settings-content-modals": "/settings-content-modals/static-1.37602",
  "diff-match-patch": "/diff-match-patch/static-1.7",
  "browser-eslint": "/browser-eslint/static-2.57",
  "checkout-service-types": "/checkout-service-types/static-1.2482",
  "company-details-components": "/company-details-components/static-1.4107",
  "payment-method-components": "/payment-method-components/static-1.4788",
  "upgrade-catalog-service-types": "/upgrade-catalog-service-types/static-1.2366",
  "access-control-lib": "/access-control-lib/static-1.8642",
  "EmailComponents": "/EmailComponents/static-1.46740",
  "EmailData": "/EmailData/static-1.45414",
  "redux-less": "/redux-less/static-2.7687",
  "company-details-service-types": "/company-details-service-types/static-1.2063",
  "billing-payments-client-types": "/billing-payments-client-types/static-1.2401",
  "ContentComponents": "/ContentComponents/static-2.64337",
  "messaging-editing-lib": "/messaging-editing-lib/static-1.38382",
  "ui-tool-access": "/ui-tool-access/static-1.8290",
  "automation-ui-types": "/automation-ui-types/static-1.12763",
  "data-token-views": "/data-token-views/static-1.13163",
  "simple-menus-core": "/simple-menus-core/static-1.12891",
  "simple-menus-lib": "/simple-menus-lib/static-1.14409",
  "ui-memberships-settings-lib": "/ui-memberships-settings-lib/static-1.26127",
  "videoconference-integration-components": "/videoconference-integration-components/static-1.4260",
  "automation-applications-service-types": "/automation-applications-service-types/static-1.2141",
  "ContentEditorUI": "/ContentEditorUI/static-2.69629",
  "short-messages-app-service-client": "/short-messages-app-service-client/static-1.2439",
  "web-interactives-components": "/web-interactives-components/static-1.10632",
  "web-interactives-data": "/web-interactives-data/static-1.10633",
  "seamless-immutable": "/seamless-immutable/static-7.6",
  "backbone": "/backbone/static-1.6",
  "content-management-data-lib": "/content-management-data-lib/static-1.3336",
  "copilot-plugins": "/copilot-plugins/static-1.4335",
  "cta-picker": "/cta-picker/static-1.29408",
  "editor-components": "/editor-components/static-1.11212",
  "editor-iframe-lib": "/editor-iframe-lib/static-1.6535",
  "error-messaging-js": "/error-messaging-js/static-1.3556",
  "pictos": "/pictos/static-7.156",
  "redux-request-state": "/redux-request-state/static-1.8845",
  "smart-content-core": "/smart-content-core/static-1.35344",
  "smart-content-lib": "/smart-content-lib/static-1.35999",
  "social-composer-lib": "/social-composer-lib/static-1.51772",
  "structured-content-lib": "/structured-content-lib/static-1.18292",
  "theme-previewer-lib": "/theme-previewer-lib/static-1.45657",
  "tinymce-copilot": "/tinymce-copilot/static-1.10066",
  "ui-active-theme-content-creator-lib": "/ui-active-theme-content-creator-lib/static-1.29456",
  "xray-recommendation-lib": "/xray-recommendation-lib/static-1.5118",
  "jquery": "/jquery/static-3.6",
  "ai-rendering-library": "/ai-rendering-library/static-1.3385",
  "ui-brand-identity-lib": "/ui-brand-identity-lib/static-1.6359",
  "fuzzy": "/fuzzy/static-1.8",
  "codemirror-dlb": "/codemirror-dlb/static-1.51181",
  "redux-undo": "/redux-undo/static-1.10",
  "highlight.js": "/highlight.js/static-1.45"
}
};
